const CODED_ROLE = { P: 'patient', D: 'doctor', F: 'front_desk', A: 'admin' };

/** Role named by a coded ID such as YMCHP00001, or null for any other identifier. */
export function codedIdRole(value) {
  const match = String(value || '').trim().toUpperCase().match(/^[A-Z]{3,5}([PDFA])\d{3,}$/);
  return match ? CODED_ROLE[match[1]] : null;
}

export const looksLikeEmail = (value) => String(value || '').includes('@');

export const looksLikePhone = (value) => {
  const digits = String(value || '').replace(/\D/g, '');
  return /^[+\d][\d\s-]{6,}$/.test(String(value || '').trim()) && digits.length >= 10 && digits.length <= 12;
};

/**
 * Which login a typed identifier belongs to: 'patient', 'doctor', 'admin', 'front_desk',
 * or 'email' when the account type cannot be told from the value alone.
 */
export function detectLoginRole(value) {
  const id = String(value || '').trim().toUpperCase();
  if (looksLikeEmail(id)) return 'email';
  if (looksLikePhone(id)) return 'patient';
  const coded = codedIdRole(id);
  if (coded) return coded;
  if (id === 'ADM01' || /^ADM-[A-Z]{3}-[A-F0-9]{6}(-\d{2,})?$/.test(id)) return 'admin';
  if (/^DOC-HSP-[A-Z]{3}-[A-F0-9]{6}-\d{5}$/.test(id)) return 'doctor';
  if (/^FDS-HSP-[A-Z]{3}-[A-F0-9]{6}-\d{5}$/.test(id)) return 'front_desk';
  return 'patient';
}
